module.exports = __webpack_public_path__ + "img/12.dbb4dc4a.png";